<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="contents">Contents</p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_tp_r1.htm#tit">Title Page</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_copnotice_r1.htm#notice">Copyright Notice</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_ded_r1.htm">Dedication</a></p>
<p class="toc-bot"><a href="#/OEBPS/9780312352080_epub_ack_r1.htm">Acknowledgments</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_p01_r1.htm"><span class="epub-b">Part One</span></a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c01_r1.htm">Chapter 1</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c02_r1.htm">Chapter 2</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c03_r1.htm">Chapter 3</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c04_r1.htm">Chapter 4</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c05_r1.htm">Chapter 5</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c06_r1.htm">Chapter 6</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c07_r1.htm">Chapter 7</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c08_r1.htm">Chapter 8</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c09_r1.htm">Chapter 9</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c10_r1.htm">Chapter 10</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c11_r1.htm">Chapter 11</a></p>
<p class="toc-bot"><a href="#/OEBPS/9780312352080_epub_c12_r1.htm">Chapter 12</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_p02_r1.htm"><span class="epub-b">Part Two</span></a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c13_r1.htm">Chapter 1</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c14_r1.htm">Chapter 2</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c15_r1.htm">Chapter 3</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c16_r1.htm">Chapter 4</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c17_r1.htm">Chapter 5</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c18_r1.htm">Chapter 6</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c19_r1.htm">Chapter 7</a></p>
<p class="toc-bot"><a href="#/OEBPS/9780312352080_epub_c20_r1.htm">Chapter 8</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_p03_r1.htm"><span class="epub-b">Part Three</span></a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c21_r1.htm">Chapter 1</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c22_r1.htm">Chapter 2</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c23_r1.htm">Chapter 3</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c24_r1.htm">Chapter 4</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c25_r1.htm">Chapter 5</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c26_r1.htm">Chapter 6</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c27_r1.htm">Chapter 7</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c28_r1.htm">Chapter 8</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c29_r1.htm">Chapter 9</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c30_r1.htm">Chapter 10</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c31_r1.htm">Chapter 11</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c32_r1.htm">Chapter 12</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c33_r1.htm">Chapter 13</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c34_r1.htm">Chapter 14</a></p>
<p class="toc-bot"><a href="#/OEBPS/9780312352080_epub_c35_r1.htm">Chapter 15</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_p04_r1.htm"><span class="epub-b">Part Four</span></a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c36_r1.htm">Chapter 1</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c37_r1.htm">Chapter 2</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c38_r1.htm">Chapter 3</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c39_r1.htm">Chapter 4</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c40_r1.htm">Chapter 5</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c41_r1.htm">Chapter 6</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c42_r1.htm">Chapter 7</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c43_r1.htm">Chapter 8</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c44_r1.htm">Chapter 9</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c45_r1.htm">Chapter 10</a></p>
<p class="toc-bot"><a href="#/OEBPS/9780312352080_epub_c46_r1.htm">Chapter 11</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_p05_r1.htm"><span class="epub-b">Part Five</span></a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c47_r1.htm">Chapter 1</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c48_r1.htm">Chapter 2</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c49_r1.htm">Chapter 3</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c50_r1.htm">Chapter 4</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c51_r1.htm">Chapter 5</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c52_r1.htm">Chapter 6</a></p>
<p class="toc-bot"><a href="#/OEBPS/9780312352080_epub_c53_r1.htm">Chapter 7</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_p06_r1.htm"><span class="epub-b">Part Six</span></a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c54_r1.htm">Chapter 1</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c55_r1.htm">Chapter 2</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c56_r1.htm">Chapter 3</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c57_r1.htm">Chapter 4</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c58_r1.htm">Chapter 5</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c59_r1.htm">Chapter 6</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c60_r1.htm">Chapter 7</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c61_r1.htm">Chapter 8</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c62_r1.htm">Chapter 9</a></p>
<p class="toc-bot"><a href="#/OEBPS/9780312352080_epub_c63_r1.htm">Chapter 10</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_p07_r1.htm"><span class="epub-b">Part Seven</span></a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c64_r1.htm">Chapter 1</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c65_r1.htm">Chapter 2</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c66_r1.htm">Chapter 3</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c67_r1.htm">Chapter 4</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c68_r1.htm">Chapter 5</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c69_r1.htm">Chapter 6</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c70_r1.htm">Chapter 7</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_c71_r1.htm">Chapter 8</a></p>
<p class="toc-bot"><a href="#/OEBPS/9780312352080_epub_c72_r1.htm">Chapter 9</a></p>
<p class="toc"><a href="#/OEBPS/9780312352080_epub_cop_r1.htm">Copyright</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312352080_epub_contents_r1.vue?ffae47e0